function configurator__elabFilter(data, scope)
{
    console.log('configurator__elabFilter', data, scope)

    if (scope == null || scope == 'vehicleType') {
        var vehicleBrand_options = $('.js-configurator-filter[data-configurator-filter="vehicleBrand"]').find('option');
        var vehicleBrand_promise = new Promise((resolve, reject) => {
            var vehicleBrand_options_counter = vehicleBrand_options.length;
            if (vehicleBrand_options_counter == 0) {
                console.log('vehicleBrand > no clean');
                resolve();
            }
            vehicleBrand_options.each(function (k, v) {
                if ($(v).attr('value')) {
                    $(v).remove();
                }

                if (!--vehicleBrand_options_counter) {
                    console.log('vehicleBrand > clean complete');
                    resolve();
                }
            });
        });

        vehicleBrand_promise.then(() => {
            console.log('vehicleBrand_promise > resolve', data.vehicleBrands);
            for(var i = 0; i < data.vehicleBrands.length; i++) {
                console.log('vehicleBrand_promise > ', data.vehicleBrands[i]);
                // var option = $('<option value="'+data.vehicleBrands[i].id+'">'+data.vehicleBrands[i].name+'</option>');
                // $('.js-configurator-filter[data-configurator-filter="vehicleBrand"]').append(option);
                $('.js-configurator-filter[data-configurator-filter="vehicleBrand"]').append($('<option>', {
                    value: data.vehicleBrands[i].id,
                    text : data.vehicleBrands[i].name
                }));
            }
        });
    }

    var vehiclePower_options = $('.js-configurator-filter[data-configurator-filter="vehiclePower"]').find('option');
    var vehiclePower_promise = new Promise((resolve, reject) => {
        var vehiclePower_options_counter = vehiclePower_options.length;
        if (vehiclePower_options_counter == 0) {
            console.log('vehiclePower > no clean');
            resolve();
        }
        vehiclePower_options.each(function (k, v) {
            if ($(v).attr('value')) {
                $(v).remove();
            }

            if (!--vehiclePower_options_counter) {
                console.log('vehiclePower > clean complete');
                resolve();
            }
        });
    });

    vehiclePower_promise.then(() => {
        console.log('vehiclePower_promise > resolve', data.vehiclePowers);
        for(var j = 0; j < data.vehiclePowers.length; j++) {
            console.log('vehiclePower_promise > ', data.vehiclePowers[j]);
            // var option = $('<option value="'+data.vehiclePowers[i].id+'">'+data.vehiclePowers[i].name+'</option>');
            // $('.js-configurator-filter[data-configurator-filter="vehiclePower"]').append(option);
            console.log($('<option>', {
                value: data.vehiclePowers[j].id,
                text : data.vehiclePowers[j].name
            }));
            $('.js-configurator-filter[data-configurator-filter="vehiclePower"]').append($('<option>', {
                value: data.vehiclePowers[j].id,
                text : data.vehiclePowers[j].name
            }));
        }
    });
}

$(document).on('change', '.js-configurator-filter', function (e) {
    var filter = $(this).attr('data-configurator-filter');

    console.log('change', '.js-configurator-filter', filter);

    if (filter == 'vehicleType') {
        var vehicleType_id = $('.js-configurator-filter[data-configurator-filter="vehicleType"]:checked').val();
        $.post('/api/configurator/filter', {
            'vehicleType': vehicleType_id
        }, function (data) {
            configurator__elabFilter(data, 'vehicleType');
        });
    } else if (filter == 'vehicleBrand') {
        var vehicleType_id = $('.js-configurator-filter[data-configurator-filter="vehicleType"]:checked').val();
        var vehicleBrand_id = $('.js-configurator-filter[data-configurator-filter="vehicleBrand"]').val();
        $.post('/api/configurator/filter', {
            'vehicleType': vehicleType_id,
            'brand': vehicleBrand_id
        }, function (data) {
            configurator__elabFilter(data, 'vehicleBrand');
        });
    }
});

$(document).on('click', '.js-configurator-reset', function (e) {
    $.post('/api/configurator/filter', {}, function (data) {
        configurator__elabFilter(data, null);
    });
});